import http from './api';

const BASE_URL = 'api/resources';
const createMicrosoftTeamsPackage = msTeamsPackageInfo => {
  return http.post(`${BASE_URL}/ms-teams/package`, msTeamsPackageInfo, {
    responseType: 'blob'
  });
};

const getMsTeamsConfiguration = orgId => {
  return http.get(`${BASE_URL}/ms-teams/configuration/${orgId}`);
};

const upsertMsTeamsConfiguration = msTeamsConfiguration => {
  return http.post(`${BASE_URL}/ms-teams/configuration`, msTeamsConfiguration);
};

export default {
  createMicrosoftTeamsPackage,
  getMsTeamsConfiguration,
  upsertMsTeamsConfiguration
};
